import $ from 'jquery'
import Swiper from 'swiper'

import cache from '../../js/utilities/cache'
import settings from '../../js/utilities/settings'
import jump from '../../js/utilities/jump'
import url from '../../js/utilities/url'

settings.recipes = {
  spice: {},
  garden: {},
}

const slider = (target, start) =>
  new Swiper(target, {
    pagination: `${target} ~ .swiper-pagination`,
    paginationClickable: true,
    direction: 'horizontal',
    speed: 250,
    grabCursor: true,
    nextButton: `${target} ~ .c-gallery__next`,
    prevButton: `${target} ~ .c-gallery__prev`,
    keyboardControl: true,
    initialSlide: start,
  })

const place = () => {
  let start = 0
  url((area, params) => {
    if (area === 'recipe') {
      const el = '#recipes'
      const $el = $(el)
      const $to = ($el.offset().top - cache.$header.outerHeight()) * 2
      jump.scrollTo($el, $to, el)
    }
    const drink = params[0]

    if (typeof drink !== 'undefined') {
      $('.c-gallery__toggle').removeClass('is-active')
      $(`#${drink}-link`).addClass('is-active')

      $('.c-gallery--recipes').addClass('js-toggle')
      $(`#${drink}`).removeClass('js-toggle')
      start = params[1] - 1
    }
  })
  return start
}

const enable = () => {
  const start = place()

  const $open = cache.$galleryRecipes.find('.open-recipe')
  const $close = cache.$galleryRecipes.find('.close-recipe')

  $open.on('click', (e) => {
    $(e.target)
      .closest('.c-gallery__front')
      .parent()
      .addClass('is-open')
  })

  $close.on('click', (e) => {
    $(e.target)
      .closest('.c-gallery__back')
      .parent()
      .removeClass('is-open')
  })

  Object.keys(settings.recipes).map((recipe) => {
    settings.recipes[recipe] = slider(`#gallery-${recipe}`, start)

    const target = `#${recipe}`

    $(`#${recipe}-link`).on('click', (e) => {
      $('.c-gallery__toggle').removeClass('is-active')

      $(e.target).addClass('is-active')

      if ($(target).hasClass('js-toggle')) {
        $('.c-gallery--recipes').addClass('js-toggle')
        $(target).removeClass('js-toggle')
        settings.recipes[recipe].update(true)
      }
    })

    return true
  })
}

export default { enable }
